import { VERIFICATION_READ_ONLY_CODE } from '@featit/shared/credentials';
import { failures } from '@featit/shared/i18n/messages/en/failures';
import { registerEnglishArea } from '@/i18n/catalogue';
import { englishT } from '@/i18n/LocaleProvider';
import { pageT } from '@/i18n/pageTranslator';

registerEnglishArea('failures', failures);

/**
 * I-2189 siblings: the sentence a verification session's refused write says, in the page's language.
 *
 * The server refuses every write a verification credential was not listed for with a 403 that carries
 * `code: 'verification-read-only'` and an English sentence. The reader is told from the code, out of the
 * catalogue (`failures.verificationReadOnly`), so a German reader reads German (AC-F: a readable refusal,
 * never a silent no-op). Null for any other failure. Read by the two places a refusal's sentence is read,
 * `actionFailure.ts` and `ApiService.httpErrorMessage`, as the plan refusal is.
 */
export function verificationReadOnlySentence(error: unknown): string | null {
  const candidate = error as {
    response?: { data?: unknown };
    extensions?: { originalError?: unknown } & Record<string, unknown>;
  } | null;
  for (const body of [
    candidate?.response?.data,
    candidate?.extensions?.originalError,
    candidate?.extensions,
  ]) {
    if ((body as { code?: unknown } | null | undefined)?.code === VERIFICATION_READ_ONLY_CODE) {
      return pageT(englishT)('failures.verificationReadOnly');
    }
  }
  return null;
}
